import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PrimeNGModule} from '../../core';
import {UserGroupService} from '../../core/services';
import {UserGroupDetailsPage, UserGroupListPage} from './pages';
import {AuthGuardService} from '../../core/auth';
import {Routes} from '@angular/router';
import {UserGroupDCreationPage} from './pages/user-group-creation/user-group-creation.page';
import {SharedModule} from '../../shared/share.module';


const routes: Routes = [
  {
    path: 'group',
    component: UserGroupListPage,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    data: {title: 'Group Overview', roles: ['AC_MANAGE_GROUP', 'AC_READ_GROUP']}
  },
];

@NgModule({
  imports: [CommonModule, PrimeNGModule, SharedModule],
  declarations: [UserGroupListPage, UserGroupDetailsPage, UserGroupDCreationPage],
  providers: [UserGroupService]
})
export class UserGroupModule {
}
